import { type JSX, type ReactNode, useMemo } from 'react';

import { useNonFavouritedExchangeCount } from '../../hooks/useNonFavouritedExchangeCount';
import { useNonFavouritedExchangeIds } from '../../hooks/useNonFavouritedExchangeIds';
import { useNonFavouritedSportsBookCount } from '../../hooks/useNonFavouritedSportsBookCount';
import { useNonFavouritedSportsBookIds } from '../../hooks/useNonFavouritedSportsBookIds';

import {
  BetNameColumn,
  BetRow,
  BookmakerColumn,
  BookmakerLogoColumn,
  GridContainer,
  GridHeaderRow,
  LeftColumn,
  OfferColumn,
} from './style';

interface OddsGridTableProps {
  children: ReactNode | ((sportsbookIds: string[], exchangeIds: string[]) => ReactNode);
  header: ReactNode;
}

export const OddsGridTable = ({ children, header }: OddsGridTableProps): JSX.Element => {
  const numberOfSportsbooks = useNonFavouritedSportsBookCount();
  const numberOfExchanges = useNonFavouritedExchangeCount();
  const sportsbookIds = useNonFavouritedSportsBookIds();
  const exchangeIds = useNonFavouritedExchangeIds();

  const renderedChildren = useMemo(() => {
    if (typeof children === 'function') {
      return children(sportsbookIds, exchangeIds);
    }
    return children;
  }, [children, sportsbookIds, exchangeIds]);

  return (
    <GridContainer numberOfExchanges={numberOfExchanges} numberOfSportsbooks={numberOfSportsbooks}>
      {header}
      {renderedChildren}
    </GridContainer>
  );
};

export { GridHeaderRow, BetRow, LeftColumn, OfferColumn, BookmakerColumn, BookmakerLogoColumn, BetNameColumn };
